import { render } from "./DeviceSettingsTab.vue?vue&type=template&id=08312f69"
import script from "./DeviceSettingsTab.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__